/**
 * created by wang lei
 媒体按钮下拉框 页面
 *
 */
import React, {Component} from 'react';

export default class MedialSelect extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        return (
            <>
                <div style={{
                    width: '119px',
                    height: '110',
                    padding: '10px 0',
                    background: '#FFFFFF',
                    color: 'rgba(0, 0, 0, 0.85)',
                    font: '12px',
                    borderRadius: '2px',
                    boxShadow: '0 9px 28px rgba(0, 0, 0, 0.1)',
                    cursor: "pointer"
                }}>
                    {this.props.children}
                </div>
                <style>
                    {
                        '.selectList:hover {background: rgba(0, 80, 179, 0.04)}'
                    }
                </style>
            </>
        )
    }

}